import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const match = window.location.hash.match(/session_id=([^&]+)/);
    if (!match) {
      nav("/login");
      return;
    }
    const sessionId = match[1];
    let pendingRef = null;
    try { pendingRef = localStorage.getItem("cgps_ref"); } catch (storageErr) {
      console.debug("localStorage unavailable", storageErr);
    }

    const exchange = async () => {
      try {
        const { data } = await api.post("/auth/google/session", {
          session_id: sessionId,
          ref: pendingRef || undefined,
        });
        let user = data.user;
        // If the user existed already and didn't get the referral via signup,
        // try a post-signup claim.
        if (pendingRef && !user.referred_by) {
          try {
            const claim = await api.post("/referrals/claim", { ref: pendingRef });
            if (claim.data.ok && claim.data.user) {
              user = claim.data.user;
              toast.success("30 Pro days added!");
            }
          } catch (claimErr) {
            // Non-fatal: claim may already have been applied or the code expired.
            console.debug("referral claim non-fatal failure", claimErr);
          }
        }
        try { localStorage.removeItem("cgps_ref"); } catch (storageErr) {
          console.debug("localStorage cleanup failed", storageErr);
        }
        setUser(user);
        window.history.replaceState(null, "", window.location.pathname);
        nav(user.onboarded ? "/dashboard" : "/onboarding", { state: { user } });
      } catch (err) {
        console.error("google session exchange failed", err);
        nav("/login");
      }
    };
    exchange();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505] text-zinc-400" data-testid="auth-callback-loading">
      Signing you in...
    </div>
  );
}
